import React from "react";

export default function KeyframePanel({
  slideIndex,
  keyframes,
  onDelete,
  onDeleteAll,   // <-- NEW PROP
  onJump,
}) {
  const list = keyframes?.[slideIndex] || [];

return (
  <div
    className="
      p-4 rounded-lg
      bg-white dark:bg-gray-900
      border border-gray-200 dark:border-gray-800
      text-gray-900 dark:text-gray-100
      transition-colors
    "
  >
    {/* Title */}
    <h2 className="text-lg font-bold mb-3">
      Keyframes – Slide {slideIndex}
    </h2>

    {/* Delete All */}
    {list.length > 0 && (
      <button
        className="
          mb-4 px-3 py-1 text-sm rounded-md
          bg-red-600 hover:bg-red-700
          text-white
          transition-colors
        "
        onClick={() => onDeleteAll(slideIndex)}
      >
        Delete All Keyframes
      </button>
    )}

    {/* Empty state */}
    {list.length === 0 && (
      <p className="text-sm text-gray-600 dark:text-gray-400">
        No keyframes for this slide.
      </p>
    )}

    {/* Keyframe list */}
    <div className="space-y-3">
      {list.map((kf, i) => (
        <div
          key={i}
          className="
            p-3 rounded-md
            flex justify-between items-center
            bg-gray-100 dark:bg-gray-800
            border border-gray-200 dark:border-gray-700
            transition-colors
          "
        >
          {/* Info */}
          <div>
            <div
              className="
                text-blue-600 dark:text-blue-400
                cursor-pointer font-medium
              "
              onClick={() => onJump(kf.time)}
            >
              @ {kf.time.toFixed(2)} sec
            </div>

            <div className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              scale: {kf.scale.toFixed(2)} | ox: {Math.round(kf.ox)} | oy:{" "}
              {Math.round(kf.oy)}
            </div>
          </div>

          {/* Delete */}
          <button
            className="
              px-2 py-1 text-xs rounded-md
              bg-red-500 hover:bg-red-600
              text-white
              transition-colors
            "
            onClick={() => onDelete(slideIndex, kf.time)}
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  </div>
);

}
